export enum ESmartControllerType {
  SMART_PLUG = "SMART_PLUG",
  AC_CONTROLLER = "AC_CONTROLLER",
}
